import React from "react";
import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "@/components/ui/accordion";
import { tinaFieldSafe } from "@/utils";
import TiptapSimpleContent from "@/components/TiptapSimpleContent";
import { cn } from "@/utils";

export default function FAQs({
  faqs,
  className,
}: {
  faqs: any;
  className?: string;
}) {
  return (
    <Accordion
      type="single"
      collapsible
      defaultValue="0"
      className={cn("max-w-3xl mx-auto", className)}
    >
      {faqs?.map((faq: any, index: number) => (
        <AccordionItem key={index} value={index.toString()}>
          <AccordionTrigger
            key={index}
            data-tina-field={tinaFieldSafe(faq, "question")}
          >
            {faq.question}
          </AccordionTrigger>
          <AccordionContent
            data-tina-field={tinaFieldSafe(faq, "answer")}
            className="max-w-5xl mb-4"
          >
            <TiptapSimpleContent
              content={faq.answer}
              className="p !text-muted-foreground-light"
            />
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
}
